/**
 * Sends a Google Analytics 4 event. A no-op unless gtag.js has loaded, which
 * only happens on public pages with the visitor's consent (see
 * components/GoogleAnalytics.tsx), so callers don't need to check either.
 *
 * Events marked as key events in GA4: generate_lead, sign_up.
 */
export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return;
  window.gtag?.('event', name, params);
}
